export default {
  clients: 'Список клиентов',
  verifications: 'Запросы верификации',
};
